import styled from "styled-components";
import { Box } from "rebass/styled-components";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ClipFullModalState } from "MVVM/State/modals";
import { ModalType } from "MVVM/@types";
import { TMomentClip } from "MVVM/Views/MatchHistory/@types";
import { MatchHistoryGame } from "MVVM/State/matchHistory";

import { PlayButton } from "MVVM/Components/PlayButton";
import { analytics } from "MVVM/Analytics";
const ClipThumbnail = ({ clip }: { clip?: TMomentClip }) => {
  const setClipFullModalState = useSetRecoilState(ClipFullModalState);
  const matchHistoryGame = useRecoilValue(MatchHistoryGame);

  return (
    <Thumbnail
      style={{
        backgroundImage: `url(${clip?.thumbnailUrl})`,
      }}
      onClickCapture={() => {
        analytics.track("Match History - Watch Clip", {
          game: matchHistoryGame,
        });

        if (clip?.shareId) {
          setClipFullModalState({
            isOpen: ModalType.Clip,
            shareId: clip?.shareId,
            contextOverride: {
              type: "match",
              metadata: {
                source: "modal",
              },
            },
          });
        }
      }}
    >
      <StyledPlayButton />
    </Thumbnail>
  );
};

const Thumbnail = styled(Box)`
  background-size: cover;
  border-radius: 6px;
  cursor: pointer;
  flex-shrink: 0;
  height: 36px;
  position: relative;
  width: 64px;

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    flex-grow: 1;
    height: inherit;
    width: 100%;
    aspect-ratio: 16/9;
  }

  :hover :first-child {
    opacity: 0.9;
  }
`;

const StyledPlayButton = styled(PlayButton)`
  height: 20px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
`;

export { ClipThumbnail };
